import React, { useState } from "react";
import styled from "styled-components";
import { CompassParagraph } from "../common/styledComponents";
import { blueText } from "../../styles";
import downArrow from "../../assets/svg/down_arrow_icon.svg";
import { Icon, IconContainer } from "../visuals/styledComponents";
import { ElementContainer } from "../containers/styledComponents";
import { UnStyledButton } from "./styledComponents";

const AnimatedIconContainer = styled(IconContainer)<{
  isPointingDown: boolean;
}>`
  padding: 0;
  margin: 0;
  transition: transform 0.3s;
  transform: ${({ isPointingDown }): string =>
    isPointingDown ? "rotate(0deg)" : "rotate(180deg)"};
`;

type ToggleAccordionBlueTextProps = {
  handleChange?: (isActive: boolean) => void;
  textActive?: string;
  textInactive?: string;
  color?: string;
  fontSize?: number;
  bold?: boolean;
  isOpen?: boolean;
};

export const ToggleAccordionBlueText = ({
  handleChange,
  textActive = "View Details",
  textInactive = "Hide Details",
  fontSize = 12,
  color = blueText,
  bold = true,
  isOpen,
}: ToggleAccordionBlueTextProps): JSX.Element => {
  const [internalState, setInternalState] = useState<boolean>(false); // start closed

  const controlled = typeof isOpen === "boolean";
  const isExpanded = controlled ? isOpen : internalState;

  const handleClick = (): void => {
    const nextState = !isExpanded;

    if (!controlled) {
      setInternalState(nextState);
    }

    handleChange?.(nextState);
  };

  return (
    <UnStyledButton onClick={handleClick}>
      <ElementContainer ai="center" cursor="pointer">
        <CompassParagraph
          bold={bold}
          color={color}
          fontSize={fontSize}
          mr={6}
          cursor="pointer"
          ws="nowrap"
        >
          {isExpanded ? textInactive : textActive}
        </CompassParagraph>
        <AnimatedIconContainer isPointingDown={!isExpanded} size={15}>
          <Icon src={downArrow} alt="toggle icon" />
        </AnimatedIconContainer>
      </ElementContainer>
    </UnStyledButton>
  );
};
